import { type WithChildren } from "@common/declarations";
import React from "react";
import Hint from "../Hint/component";

import "./style.less";

type Props = WithChildren & {
  style?: React.CSSProperties;
};
const InfoPreview = (props: Props) => (
  <div className="info_preview" style={props.style}>
    {props.children}
  </div>
);
export default InfoPreview;

type LineProps = {
  label: string;
  value: any;
};
InfoPreview.Line = (props: LineProps) =>
  props.value ? (
    <div className="line">
      <Hint className="label">{props.label}</Hint>
      <span className="value" title={props.value}>
        {props.value}
      </span>
    </div>
  ) : null;
